<template>
  <div class="padding-50 k-page">
    <Row :gutter="20">
      <i-col :xs="24" :sm="12" :md="16">
        <Card>
          <div class="padding-20 text-center" style="background:#646464;color:#ffffff;">
            <h3>Frequently Asked Questions</h3>
          </div>
          <Collapse simple accordion v-model="activePanel" class="faq-accordion">
            <Panel v-for="(faq, idx) in faqs" :key="idx" :name="'faq-'+idx" class="padding-t-20">
              <b style="font-size:16px;">{{ faq.question }}</b>
              <div slot="content">
                <div class="support-desc" style="padding: 15px 40px 0px;">
                  <div v-if="faq.answers.length">
                    <div :class="(idx > 0)? 'padding-t-20':''" v-for="(ans, idx) in faq.answers" :key="idx">
                      <p v-html="ans.answer"></p>
                      <div class="text-center">
                        <myVideo
                          :sources="[{
                            src: ans.video,
                            type: 'video/mp4'
                          }]"
                          :options="{
                            autoplay: false,
                            volume: 0.6
                          }"
                          v-if="ans.video"
                          class="padding-t-20">
                        </myVideo>
                        <div class="img-con" v-if="ans.image" style="height: 300px;overflow:hidden;">
                          <img height="100%" width="auto" :src="ans.image" class="padding-t-20"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Panel>
          </Collapse>
        </Card>
      </i-col>
      <i-col :xs="24" :sm="12" :md="8">
        <Card>
          <div class="padding-20 text-center" style="background:#646464;color:#ffffff;">
            <h3>Contact us</h3>
          </div>
          <div class="logo-con text-center padding-bt-20">
            <img alt="Kromnix logo" src="@/assets/images/logo/kromnix-logo-main.png" width="150px"/>
            <p class="width-80 margin-auto padding-b-20">Please feel free to contact us if you have any specific questions about your account.</p>
            <p>CONTACT US</p>
            <p><a href="mailto:contact-us@kromnix.com">contact-us@kromnix.com</a></p>
          </div>
        </Card>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { getFaq } from '@/services/faq'
import myVideo from 'vue-video'

export default {
  components: {
    myVideo
  },

  data () {
    return {
      faqs: null,
      isLoading: false,
      activePanel: null
    }
  },

  mounted () {
    this.getFaq()
  },

  methods: {
    getFaq () {
      this.isLoading = true
      getFaq().then(res => {
        this.faqs = res.data.results
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get faq: ', err)
      })
    }
  }
}
</script>

<style lang="scss">
.faq-accordion {
  border: 0px;
  .ivu-collapse-item {
    border: 0px;
    .ivu-collapse-header {
      background: $secondary;
      color: #ffffff !important;
      border-radius: 3px;
    }
  }
}
</style>
